// extracted by css-extract-rspack-plugin
export default {"editor_table":"EcSE3tGFDfED6eXk"};